export default __webpack_public_path__ + "static/media/munis.243fe879.png";